import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'src/app/shared/services/alert.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { GlobalService } from 'src/app/shared/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { THIS_EXPR, typeofExpr } from '@angular/compiler/src/output/output_ast';
import { UtilService } from 'src/app/shared/services/util.service';
import { VehiculoFuncionarioModel } from 'src/app/models/vehiculoFuncionario.model';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { Subscription } from 'rxjs';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { $ } from 'protractor';
import { VehiculoFuncionario } from 'src/app/models/administrarFuncionario.model';


@Component({
    selector: 'app-modal-registrar-vehiculo',
    templateUrl: './modal-registrar-vehiculo.component.html'
})
export class ModalRegistrarVehiculoComponent implements OnInit {

    modalOptions: any;
    accept: string;
    public placa: string;
    public otro: string;
    public nuevoVehiculo: VehiculoFuncionario;
    public dominios: DetalleDominio[] = [];
    public listadoTipoVehiculo;
    private subscription: Subscription[];

    soportes: File[];
    observaciones: string;

    constructor(
        private activeModal: NgbActiveModal,
        private alertService: AlertService,
        private urlService: UrlService,
        private global: GlobalService,
        private spinner: NgxSpinnerService,
        private utilService: UtilService,
        private modalService: NgbModal,
    ) {
        this.listadoTipoVehiculo = [];
    }

    ngOnInit() {
        this.nuevoVehiculo = new VehiculoFuncionarioModel();
        this.modalOptions = new ConfirmationModalOptions(
            'Confirmación', ConstantesService.MENSAJE_CONFIRMACION_INSCRIPCION_COMPENSACION,
            'SI', 'NO', 'fas fa-save', false, false,
            'Guardar',
            null, 'btn-secondary');
        this.accept = '.pdf';
        this.soportes = [];
    }

    getTipoVehiculo(vehiculo: string) {
        this.placa = null;
        this.otro = null;

        this.nuevoVehiculo.tipoVehiculo = vehiculo;
    }

    // /**
    //  * klagos
    //  * método que realiza la petición con los datos de guardado
    //  * @param valor
    //  */
    // public getTipoVehiculo(valor: any) {

    //     this.nuevoVehiculo = valor;
    //     const idvehiculo = 'btn-' + valor;
    //     const b = document.getElementById(idvehiculo);

    //     if (b && this.nuevoVehiculo.tipoVehiculo !== valor) {
    //         this.nuevoVehiculo.placa = '';
    //         this.nuevoVehiculo.tipoVehiculo = valor;
    //         $('.tipovehiculo').removeClass('selected');
    //         b.classList.add('selected');
    //     }

    // }

    guardarVehiculo() {
        this.nuevoVehiculo.placa = this.placa;
        this.nuevoVehiculo.fechaRegistro = new Date();
        this.nuevoVehiculo.otro = this.otro;
        this.activeModal.close(this.nuevoVehiculo);
    }

    cerrar() {
        this.activeModal.close();
    }

    validarFormulario(): boolean {
        if ((this.nuevoVehiculo.tipoVehiculo == "CARRO" || this.nuevoVehiculo.tipoVehiculo == "MOTO") && this.placa) {
            this.otro = "NO APLICA"
            return false;
        }

        if (this.nuevoVehiculo.tipoVehiculo == "BICICLETA") {
            this.placa = "NO APLICA"
            this.otro = "NO APLICA"
            return false;
        }

        if (this.nuevoVehiculo.tipoVehiculo == "OTRO" && this.otro) {
            this.placa = "NO APLICA"
            return false;
        }

        return true;
    }

    /**
     * klagos
     * obtiene los tipos de vehiculo
     */
    public obtenerTipoVehiculo() {
        this.spinner.show();
        const serviceProvider = 'ObtenerTipoVehiculo';
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
            this.urlService.hostAPI_FUNCIONARIOS);
        const subscribe = this.global.getGenerico(url).subscribe(
            data => {
                this.listadoTipoVehiculo = data;
                this.listadoTipoVehiculo.forEach(element => {
                    const i = this.listadoTipoVehiculo.indexOf(element);
                    if (element.valor === 'No') {
                        this.listadoTipoVehiculo.splice(i);
                    }
                });
                // data = data.pop();
                this.spinner.hide();
            }, err => {
                this.catchException('Error consultando el dominio');
            }
        );
        this.subscription.push(subscribe);
    }

    /**
     * Método de control de Excepciones
     * @param error mensaje saliente respecto al error ocurrido
     */
    catchException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }
}
